import React from "react";
import classNames from "classnames";

import { PropsTypeElemIndicatorSVG } from "@typings/global.types";

function ElemIndicatorSVG({
  classNameProps,
  d,
  colorPathCircle,
  height,
  width,
  strokeDashoffset,
}: PropsTypeElemIndicatorSVG) {
  const elemClass =
    strokeDashoffset === 0
      ? "fill-brand-secondary dark:fill-brand-dark-secondary"
      : "fill-icon-secondary dark:fill-icon-dark-secondary";
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(classNameProps)}
      width={width}
      height={height}
      viewBox='0 0 70 70'
      fill='none'
    >
      <circle
        cx='35'
        cy='35'
        r='24'
        className='dark:stroke-brd-dark-primary stroke-brd-primary'
        strokeWidth='6'
      />
      <path
        d='M35 11C38.1517 11 41.2726 11.6208 44.1844 12.8269C47.0962 14.033 49.742 15.8008 51.9706 18.0294C54.1992 20.258 55.967 22.9038 57.1731 25.8156C58.3792 28.7274 59 31.8483 59 35C59 38.1517 58.3792 41.2726 57.1731 44.1844C55.967 47.0962 54.1992 49.742 51.9706 51.9706C49.742 54.1992 47.0962 55.967 44.1844 57.1731C41.2726 58.3792 38.1517 59 35 59C31.8483 59 28.7274 58.3792 25.8156 57.1731C22.9038 55.967 20.258 54.1992 18.0294 51.9706C15.8008 49.7419 14.033 47.0962 12.8269 44.1844C11.6208 41.2726 11 38.1517 11 35C11 31.8483 11.6208 28.7274 12.8269 25.8156C14.033 22.9038 15.8008 20.258 18.0294 18.0294C20.2581 15.8008 22.9038 14.033 25.8156 12.8269C28.7274 11.6208 31.8483 11 35 11L35 11Z'
        className={classNames(colorPathCircle)}
        strokeWidth='6'
        strokeDasharray='150'
        strokeDashoffset={strokeDashoffset}
        strokeLinecap='round'
      />
      <path
        xmlns='http://www.w3.org/2000/svg'
        fillRule='evenodd'
        clipRule='evenodd'
        d={d}
        className={classNames(elemClass)}
      />
    </svg>
  );
}

export default ElemIndicatorSVG;
